import { cx } from "@emotion/css"

import Anchor from "@p-ban/common/src/components/html/Anchor"
import useHover from "@p-ban/common/src/hooks/useHover"

import listItemStyles from "./listItemStyle"

type Props = {
  children: React.ReactNode
  href: string
  newTab?: boolean
  className?: string
  hoverClassName?: string
}

const ListItem = ({ children, href, newTab, className, hoverClassName }: Props) => {
  const { isHovered, hoverProps } = useHover()

  const contentClassName = cx(listItemStyles.content, className, isHovered && (hoverClassName || listItemStyles.hover))

  return (
    <li {...hoverProps} className={listItemStyles.li}>
      <Anchor href={href} className={contentClassName} newTab={newTab}>
        {children}
      </Anchor>
    </li>
  )
}

export default ListItem
